import React from 'react';
import { QlikUIContext, Dashboard, QlikWrapper } from 'globaleris-qlik-component';
import 'globaleris-qlik-component/dist/index.css';

import Page from '../../components/page/page';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../components/page/pageHeader';
import { useQlikContext } from '../../hooks/useQlikContext';

export const DashboardPage = () => {
  const [t] = useTranslation(['globalerisLibrary', 'qlik']);

  const { isContextInitialized, context } = useQlikContext();

  return (
    <Page>
      <PageHeader title={`${t('qlik:dashboardTitle')}`}></PageHeader>
      {isContextInitialized &&
        <QlikUIContext.Provider value={context}>
          {<QlikWrapper component={<Dashboard />} />}
        </QlikUIContext.Provider>
      }
    </Page>
  );
};
